import { SelectField } from '@flos/react-ui';
import type { YesNo_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import type { AttributeChangeProps } from '../../../types';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { callMeVariantOpcAtom } from '../../../../../recoil/atoms/callMeVariantOpcAtom';
import { getCoverableInfoSelector } from '../../../../../recoil/selectors/getCoverableInfoSelector';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { isOpcFetchingAtom } from '../../../../../recoil/atoms/isOpcFetchingAtom';

export const voluntaryAlarmOptions: Array<{ label: string; value: YesNo_Top }> = [
    {
        label: 'Ja',
        value: 'Yes'
    },
    {
        label: 'Nej',
        value: 'No'
    }
];

const ContentVoluntaryAlarmChange = ({
    updateCoverableAttribute
}: AttributeChangeProps): JSX.Element => {
    const getHippoText = useHippoText();
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const isOpcFetching = useRecoilValue(isOpcFetchingAtom);
    const setCallMeVariant = useSetRecoilState(callMeVariantOpcAtom);
    const { isPRCVoluntaryAlarmNo } = useRecoilValue(getCoverableInfoSelector);
    return (
        <>
            <p>{getHippoText('DSS-EDIT-ATTRIBUTE-ALARM-DESCRIPTION')}</p>
            <h6>{getHippoText('DSS-EDIT-ATTRIBUTE-ALARM-SUBHEADER')}</h6>
            <SelectField
                iconShape="search"
                label={getHippoText('DSS-EDIT-ATTRIBUTE-ALARM-HEADER')}
                options={voluntaryAlarmOptions}
                onChange={(e) => {
                    const selectedIndex = e.target.selectedIndex;
                    const { value } = e.target.options[selectedIndex];
                    if (isPRCVoluntaryAlarmNo && (value as YesNo_Top) === 'Yes') {
                        setCallMeVariant('voluntaryAlarmNoToYes');
                        return;
                    }
                    updateCoverableAttribute({ voluntaryAlarm: value as YesNo_Top });
                    setIsOpcDataFilled(true);
                }}
                disabled={isOpcFetching}
            ></SelectField>
        </>
    );
};

export default ContentVoluntaryAlarmChange;
